import React from "react"
import Modal from "components/dialogs/Modal"
import { Box, Stack, Text } from "@chakra-ui/react"
import { FormType, Guest } from "sharedTypes"
import GuestAvatarAndName from "components/elements/GuestAvatarAndName"
import { useForms } from "queries/forms"
import Spinner from "components/elements/Spinner"
import UrlRow from "./UrlRow"

type Props = {
  onHide: () => void
  guest: Guest
  eventId: string
}

const ViewGuestLinks = ({
  onHide,
  guest,
  eventId,
}: Props) => (
  <Modal
    title="Guest Links"
    show
    hide={onHide}
    size="2xl"
  >
    <ModalContent guest={guest} eventId={eventId} />
  </Modal>
)

type ModalContentProps = {
  guest: Guest
  eventId: string
}

const ModalContent = ({ guest, eventId }: ModalContentProps) => {
  const { isLoading: formsLoading, data } = useForms(eventId)

  if (formsLoading) {
    return <Spinner />
  }

  const forms = data?.data || []

  const filteredForms = forms.filter(
    ({ type, disabled }) => [
      FormType.RSVP,
      FormType.Survey,
    ].includes(type) && !disabled,
  )

  const { page: guestLink, qr: guestQRLink, forms: guestFormLinks = {} } = guest.urls ?? {}

  return (
    <>
      <GuestAvatarAndName guest={guest} fontSize="lg" />
      <Stack ml={14}>
        <Stack pt={4} pb={6} borderBottomWidth={1}>
          <Text fontWeight="semibold">Guest Portal</Text>
          <Text>The guest&apos;s main event page showing their confirmation status,
            invitations, and registration form links.
          </Text>
          <UrlRow url={guestLink} />
        </Stack>
        <Stack pt={4} pb={6} borderBottomWidth={1}>
          <Text fontWeight="semibold">Dedicated QR Page</Text>
          <Text>Displays the guest&apos;s QR code and event details if they are <Text as="strong" fontWeight="semibold" fontStyle="italic">confirmed</Text>.
          </Text>
          <UrlRow url={guestQRLink} />
        </Stack>
        <Stack spacing={3} py={4}>
          <Box>
            <Text fontWeight="semibold">Forms</Text>
            <Text>Unique RSVP and Survey links that only this guest can use.
            </Text>
          </Box>
          {filteredForms.map(({ name, externalId }) => guestFormLinks[externalId] && (
            <Box key={externalId}>
              <Text fontWeight="semibold">{name}</Text>
              <UrlRow url={guestFormLinks[externalId]} />
            </Box>
          ))}
        </Stack>
      </Stack>
    </>
  )
}

export default ViewGuestLinks
